import { render, staticRenderFns } from "./ReportTemplate.vue?vue&type=template&id=0463c5c8&scoped=true&"
import script from "./ReportTemplate.vue?vue&type=script&lang=js&"
export * from "./ReportTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463c5c8",
  null
  
)

export default component.exports